import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import { TriggerType } from 'common/flow/constants/TriggerType'

import { LightFlow, LightFlowSchema } from './lightFlow'

export const MainMenuTriggerSchema = z.object({
  title: z.string(),
  captions: z.array(z.string()).optional(),
  caption: z.string().optional(),
  channel: z.nativeEnum(ChannelType).optional(),
  id: z.string(),
  ts_created: z.number().optional(),
  type: z.literal(TriggerType.MAIN_MENU),
})

export type MainMenuTrigger = z.infer<typeof MainMenuTriggerSchema>

export interface MappedLightFlow extends LightFlow {
  id: string
  contentId: number | null
  hasDraft: boolean
}

export type { FlowContent, FlowDefaultContent } from './flowContent'

export type {
  Flow,
  FlowStats,
  NewFlowStats,
  TriggerRule,
  ExternalTrigger,
  ExternalTriggerData,
  ExternalTriggerAppData,
  ExternalTriggerContext,
  ExternalTriggerHotmartPostPurchaseChangeStatusData,
  ExternalTriggerTikTokAdData,
  AnotherFlowTrigger,
  ConversationStarter,
  DraftBatch,
  FollowReply,
} from './flow'

export type { LightFlow } from './lightFlow'

export { LightFlowSchema }
